import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon/Icon';

export const Clock2Icon: ComponentWithAs<'svg', IIconProps> = (props: any) => (
  <Icon data-testid="clock 2 icon" viewBox="0 0 12 12" {...props}>
    <path
      d="M6.50001 2.66663C6.50001 2.39048 6.27615 2.16663 6.00001 2.16663C5.72386 2.16663 5.50001 2.39048 5.50001 2.66663V5.99996C5.50001 6.17235 5.58882 6.33259 5.73501 6.42396L7.73501 7.67396C7.96917 7.82031 8.27765 7.74913 8.424 7.51496C8.57036 7.28079 8.49917 6.97232 8.26501 6.82596L6.50001 5.72284V2.66663Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M6.00001 0.166626C2.77834 0.166626 0.166672 2.7783 0.166672 5.99996C0.166672 9.22162 2.77834 11.8333 6.00001 11.8333C9.22167 11.8333 11.8333 9.22162 11.8333 5.99996C11.8333 2.7783 9.22167 0.166626 6.00001 0.166626ZM1.16667 5.99996C1.16667 3.33058 3.33063 1.16663 6.00001 1.16663C8.66938 1.16663 10.8333 3.33058 10.8333 5.99996C10.8333 8.66934 8.66938 10.8333 6.00001 10.8333C3.33063 10.8333 1.16667 8.66934 1.16667 5.99996Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
);
